import { render, staticRenderFns } from "./Penalty.vue?vue&type=template&id=b1b64bc2&scoped=true"
import script from "./Penalty.vue?vue&type=script&lang=js"
export * from "./Penalty.vue?vue&type=script&lang=js"
import style0 from "./Penalty.vue?vue&type=style&index=0&id=b1b64bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b64bc2",
  null
  
)

export default component.exports